import React from 'react';
import { Info } from 'lucide-react';
import type { Campaign } from '../../types';

export function ReviewReleaseBanner({ campaign }: { campaign: Campaign | null }) {
  const setting = campaign?.autoReleaseStaleReviews;
  if (setting?.enabled !== true) return null;
  const hours = setting.hours ?? 4;
  return (
    <div
      role="note"
      aria-label="Automatic review release"
      className="my-3 flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900"
    >
      <Info aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0" />
      <p>
        Claimed reviews left untouched for {hours} {hours === 1 ? 'hour' : 'hours'} will be
        released back into the review queue, including reviews sent back after rework.
      </p>
    </div>
  );
}
